import { gql } from '@apollo/client';

/**
 * Payouts-internal Ops queries/mutations for AMC collection accounts (listed vendors).
 *
 * These wrap the SUPER_ADMIN / BACKEND_SCRIPT_RUNNER guarded resolvers in
 * kodo-backend `payment.resolver.ts`. They are NOT part of the treasury REST
 * surface — treasury never calls them. Field names below are verified against
 * `kodo-backend/src/modules/payment/graphql/payment.graphql`.
 */

// mutation pvtBulkImportHiddenListedVendorsForKodoPay(
//   input: BulkImportHiddenListedVendorsForKodoPayInput!
// ): BulkImportHiddenListedVendorsForKodoPayOutput!
export const pvtBulkImportHiddenListedVendorsForKodoPayGQL = gql`
mutation pvtBulkImportHiddenListedVendorsForKodoPay(
  $input: BulkImportHiddenListedVendorsForKodoPayInput!
) {
  pvtBulkImportHiddenListedVendorsForKodoPay(input: $input) {
    totalRows
    created
    skipped
    failed
    results {
      vendorName
      accountNumber
      ifsc
      status
      error
    }
  }
}
`;

// mutation pvtUpdateListedVendorForKodoPay(input: UpdateVendorInput): String
// UpdateVendorInput { vendorId: ID!, emailId: String, isHiddenFromUser: Boolean }
export const pvtUpdateListedVendorForKodoPayGQL = gql`
mutation pvtUpdateListedVendorForKodoPay($input: UpdateVendorInput) {
  pvtUpdateListedVendorForKodoPay(input: $input)
}
`;

// mutation pvtToggleVirtualAccountForListedVendor(input: ToggleVirtualAccountForListedVendorInput!): String!
// ToggleVirtualAccountForListedVendorInput { vendorId: ID!, isVirtualAccount: Boolean! } — AMC collection accounts only.
export const pvtToggleVirtualAccountForListedVendorGQL = gql`
mutation pvtToggleVirtualAccountForListedVendor($input: ToggleVirtualAccountForListedVendorInput!) {
  pvtToggleVirtualAccountForListedVendor(input: $input)
}
`;

// query pvtGetAmcCollectionAccountsForKodoPay(input: AmcCollectionAccountListInput!): AmcCollectionAccountList!
// AmcCollectionAccountListInput { pagination: PaginationOptions!, keyword: String }
// The konsole getList passes `$pagination` ({ page, limit }) and spreads metaData, so `$keyword` comes
// from metaData.keyword; the input object is assembled here.
export const pvtGetAmcCollectionAccountsForKodoPayGQL = gql`
query pvtGetAmcCollectionAccountsForKodoPay($pagination: PaginationOptions!, $keyword: String) {
  pvtGetAmcCollectionAccountsForKodoPay(input: { pagination: $pagination, keyword: $keyword }) {
    items {
      vendorId
      vendorName
      accountNumber
      ifsc
      accountHolderName
      isHiddenFromUser
      isVirtualAccount
      createdAt
    }
    meta {
      totalItems
      itemCount
      itemsPerPage
      totalPages
      currentPage
    }
  }
}
`;

export const AmcListedVendorGQL = {
  pvtGetAmcCollectionAccountsForKodoPay: pvtGetAmcCollectionAccountsForKodoPayGQL,
  pvtBulkImportHiddenListedVendorsForKodoPay: pvtBulkImportHiddenListedVendorsForKodoPayGQL,
  pvtUpdateListedVendorForKodoPay: pvtUpdateListedVendorForKodoPayGQL,
  pvtToggleVirtualAccountForListedVendor: pvtToggleVirtualAccountForListedVendorGQL,
};
